<div class="container-list-item" [style]="'grid-template-columns: ' + gridColumnsWidths">
  <ng-content></ng-content>
</div>
